/**
 * Constantes y datos relacionados con Bancos y Medios de Pago
 */

export const BANCOS = [
    { codigo: '001', nombre: 'BANCO DE CHILE - EDWARDS' },
    { codigo: '028', nombre: 'BANCO BICE' },
    { codigo: '055', nombre: 'BANCO CONSORCIO' },
    { codigo: '012', nombre: 'BANCO DEL ESTADO DE CHILE' },
    { codigo: '017', nombre: 'BANCO DO BRASIL S.A' },
    { codigo: '051', nombre: 'BANCO FALABELLA' },
    { codigo: '009', nombre: 'BANCO INTERNACIONAL' },
    { codigo: '057', nombre: 'BANCO PARIS' },
    { codigo: '053', nombre: 'BANCO RIPLEY' },
    { codigo: '037', nombre: 'BANCO SANTANDER' },
    { codigo: '049', nombre: 'BANCO SECURITY' },
    { codigo: '504', nombre: 'BBVA (BCO BILBAO VIZCAYA ARG)' },
    { codigo: '016', nombre: 'BCI (BCO DE CREDITO E INV)' },
    { codigo: '672', nombre: 'COOPEUCH' },
    { codigo: '741', nombre: 'COPEC PAY' },
    { codigo: '031', nombre: 'HSBC BANK' },
    { codigo: '039', nombre: 'ITAU CHILE' },
    { codigo: '027', nombre: 'ITAU CORPBANCA' },
    { codigo: '697', nombre: 'LA POLAR PREPAGO' },
    { codigo: '875', nombre: 'MERCADO PAGO' },
    { codigo: '729', nombre: 'PREPAGO LOS HEROES' },
    { codigo: '014', nombre: 'SCOTIABANK' },
    { codigo: '732', nombre: 'TAPP CAJA LOS ANDES' },
    { codigo: '730', nombre: 'TENPO PREPAGO S.A' },
];

export const MEDIOS_DE_PAGO = [
    { codigo: 1, nombre: 'ABONO CUENTA CORRIENTE BANCO DE CHILE' },
    { codigo: 2, nombre: 'VALE VISTA ENTREGADO EN MESON BANCO' },
    { codigo: 4, nombre: 'VALE VISTA ENTREGADO A LA EMPRESA' },
    { codigo: 6, nombre: 'ABONO CUENTA AHORRO BANCO DE CHILE' },
    { codigo: 7, nombre: 'ABONO CUENTA CORRIENTE DE OTRO BANCO' },
    { codigo: 8, nombre: 'ABONO CUENTA AHORRO DE OTRO BANCO' },
    { codigo: 11, nombre: 'ABONO BANCUENTA CREDICHILE' },
    { codigo: 12, nombre: 'PAGO EN EFECTIVO SERVIPAG' },
];

/**
 * Reglas de validación para formularios de pago
 */
export const REGLAS_PAGO = {
    medioPago: {
        required: true,
        message: 'Seleccione el código que determina la forma de pago que se realizará'
    },
    rutBeneficiario: {
        required: true,
        message: 'Ingrese RUT del titular de la cuenta de destino sin puntos, sin guión y sin dígito verificador',
        format: /^[0-9]+$/ // Solo números
    },
    dvBeneficiario: {
        required: true,
        message: 'Ingrese Sin guión',
        maxLength: 1
    },
    nombreBeneficiario: {
        required: true,
        maxLength: 60,
        message: 'Ingrese nombre titular de la cuenta de destino. Máximo 60 caracteres.'
    },
    codigoBanco: {
        required: true,
        message: 'Seleccione el código de Banco de la cuenta de destino'
    },
    numeroCuenta: {
        required: true,
        maxLength: 20,
        format: /^[a-zA-Z0-9]+$/, // Letras y números, sin caracteres especiales
        message: 'Ingrese número de cuenta de destino. Máximo 20 caracteres, permite letras y números. Evite caracteres especiales como puntos y guiones'
    },
    montoPago: {
        required: true,
        format: /^[0-9]+$/, // Solo cifras
        message: 'Ingrese sólo la cifra, sin caracteres especiales como puntos y/o signo peso.'
    },
    descripcionPago: {
        required: false,
        maxLength: 119,
        message: 'Opcional. Ingrese texto de hasta 119 caracteres. Ejemplo: "Remuneración Abril"'
    },
    mailDestino: {
        required: false,
        message: 'Opcional. Ejemplo: "beneficiario@correo.com"'
    },
    mensaje: {
        required: false,
        maxLength: 256,
        message: 'Opcional. Ingrese hasta 256 caracteres. Ejemplo: "Remuneración de abril que incluye bono anual. Gracias."'
    }
};
